import { api } from '../../lib/api';
import type {
  BroadcastPayload,
  BroadcastRecord,
  PreviewResponse,
} from './types';

export function fetchBroadcasts(): Promise<BroadcastRecord[]> {
  return api.get<BroadcastRecord[]>('/admin/broadcasts');
}

export function previewBroadcast(payload: { audience: BroadcastPayload['audience'] }): Promise<PreviewResponse> {
  return api.post<PreviewResponse>('/admin/broadcasts/preview', payload);
}

export function sendBroadcast(
  payload: BroadcastPayload,
  stepUpToken?: string,
): Promise<BroadcastRecord> {
  return api.post<BroadcastRecord>('/admin/broadcasts/send', payload, { stepUpToken });
}
